import React from 'react';

const VECIErrorMessage = ({ error }) => {
  if (!error) return null;
  return (
    <div className='text-danger extra-small mt-1 animate-slide-up'>
      <i className='bi bi-exclamation-circle me-1'></i> {error.message}
    </div>
  );
};

export default VECIErrorMessage;
